export default __webpack_public_path__ + "assets/Picture11.png";